import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

// Material
import Box from "@material-ui/core/Box";

// Config
import styles from "src/config/styles";

// Components
import Text from "src/components/Text";
import PageBreadcrumb from "./PageBreadcrumb";

const useStyles = makeStyles(theme => ({
  boxTitle: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2, 3),
    borderBottom: styles.values.border
  }
}));

// Shared header for both steps of the statement form (content and review): a
// heading2 title (SAI vs. own template title) followed by the page breadcrumb.
// `extraStepLabel` is only passed by the review step, to append "Review" as the
// breadcrumb's final entry.
const FormSectionHeader = ({
  isSai,
  titleKey,
  pages,
  pageIndex,
  maxPageIndex,
  onNavigate,
  extraStepLabel
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.boxTitle}>
      <Text
        type="heading2"
        text={
          isSai
            ? "caseMenu.caseSummary.selfAdministeredInterviews.title"
            : titleKey
        }
      />
      <PageBreadcrumb
        pages={pages}
        pageIndex={pageIndex}
        maxPageIndex={maxPageIndex}
        onNavigate={onNavigate}
        extraStep={extraStepLabel ? { label: extraStepLabel } : null}
      />
    </Box>
  );
};

FormSectionHeader.propTypes = {
  isSai: PropTypes.bool.isRequired,
  titleKey: PropTypes.string.isRequired,
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string
    })
  ).isRequired,
  pageIndex: PropTypes.number.isRequired,
  maxPageIndex: PropTypes.number.isRequired,
  onNavigate: PropTypes.func.isRequired,
  extraStepLabel: PropTypes.string
};

FormSectionHeader.defaultProps = {
  extraStepLabel: null
};

export default FormSectionHeader;
